import React from 'react';
import { ChatMessage } from '@/components/module/chats';
import RichTextEditor from '@/components/ui/RichTextEditor';
import {
    getDiscussionContentHtml,
    getDiscussionAuthorName,
    getDiscussionAuthorInitials,
    getDiscussionAuthorId,
    formatDiscussionTimestamp,
} from '@hooks/projects/projectHelpers';
import { formatChatMessageTime } from '@utils/dateFormating.util';
import {
    resolveAttachmentPlaceholders,
    mergeMentionsWithUsers,
    resolveMentionPlaceholders,
} from '@hooks/projects/discussion/utils/discussionPanel.utils';

export function DiscussionContentEditor({ mentionUsers, mentionMilestones, mentionSprints, hashtagTags, ...props }) {
    return (
        <RichTextEditor
            placeholder="Write your message (bold, italic, lists). Type @ to mention someone, milestone, or sprint…"
            showAttachButton
            mentionUsers={mentionUsers}
            mentionMilestones={mentionMilestones}
            mentionSprints={mentionSprints}
            hashtagTags={hashtagTags}
            {...props}
        />
    );
}

export function DiscussionPostChatRow({
    post,
    currentUserId,
    currentUserName,
    mentionUsers,
    mentionMilestones,
    mentionSprints,
    flatTasks,
    projectBugs,
    projectBlockers,
    timeFormat,
    onEdit,
    onDelete,
    editPending,
    deletePending,
}) {
    const rawHtml = getDiscussionContentHtml(post);
    const attachments = post.attachments ?? [];
    const mergedMentions = mergeMentionsWithUsers(post.mentions ?? [], mentionUsers);
    const htmlWithMentions = resolveMentionPlaceholders(rawHtml, {
        mentions: mergedMentions,
        milestones: post.milestones ?? mentionMilestones,
        sprints: post.sprints ?? mentionSprints,
        tasks: post.tasks ?? flatTasks,
        bugs: post.bugs ?? projectBugs,
        blockers: post.blockers ?? projectBlockers,
    });
    const html = resolveAttachmentPlaceholders(htmlWithMentions, attachments);
    const created = post.createdAt ?? post.created_at ?? post.date;
    const timeLabel =
        timeFormat === 'absolute' ? formatDiscussionTimestamp(created) : formatChatMessageTime(created);
    const authorId = getDiscussionAuthorId(post);
    const isOwn = String(authorId) === String(currentUserId);
    const senderName = isOwn ? currentUserName || 'You' : getDiscussionAuthorName(post);

    return (
        <ChatMessage
            messageId={post.id ?? post.discussionId}
            userId={authorId ?? senderName}
            senderName={senderName}
            time={timeLabel}
            body={html}
            attachments={attachments}
            initials={getDiscussionAuthorInitials(post)}
            isOwn={isOwn}
            reactions={[]}
            onEdit={onEdit}
            onDelete={onDelete}
        />
    );
}

